import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('TAGS_BLOG').plugin(axiosPlugin);

let fetchTagsBlogAction = redux.fetchActionGetOne();


export const fetchTagsBlog = (query = {}) => fetchTagsBlogAction(`/tags/blog?${queryString.stringify(query)}`);

export const tagsBlog = redux.reducer();